import { Typography } from "@mui/material";

export default function AccordionTitle(props) {
  const { children } = props;
  return <Typography color="default">{children}</Typography>;
}
